import loggingApi, { LOG_GROUP } from '@sleepstation/logger'
import { prettyPrintObj, replaceTokens } from '@sleepstation/utils'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useMutation } from 'urql'
import { CreateLogEntryMutation } from '../../graphql/documents'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const logger = loggingApi.getLogger({
  group: LOG_GROUP.PAGE_MONITOR_SERVICE,
})

const LOG_ENTRY_ACTION = `REQUEST_GET`
const LOG_ENTRY_DESCRIPTION_TEMPLATE = `GET #{href}`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getDescription = replaceTokens(LOG_ENTRY_DESCRIPTION_TEMPLATE)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PageMonitorService = ({ location, currentEnrolment }) => {
  const { href } = location
  const { id: enrolmentId } = currentEnrolment

  const [createLogEntryResult, createLogEntry] = useMutation(
    CreateLogEntryMutation
  )

  const { fetching, error, data } = createLogEntryResult

  useEffect(() => {
    if (!fetching && !error && data) {
      const dataString = prettyPrintObj(data.createLogEntry)
      logger.info(`Logged Page View ${dataString}`)
    }
  }, [createLogEntryResult?.data?.createLogEntry, error, data, fetching])

  useEffect(() => {
    const description = getDescription({ href })
    const datetime = dayjs().format()

    createLogEntry({
      enrolmentId,
      action: LOG_ENTRY_ACTION,
      description,
      datetime,
    })
  }, [href, createLogEntry, enrolmentId])

  return null
}

PageMonitorService.propTypes = {
  currentEnrolment: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export default PageMonitorService
